function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 24
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 24,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M139.581,19.162a9.581,9.581,0,1,1,9.581-9.581A9.609,9.609,0,0,1,139.581,19.162Zm4.79-14.371L139.7,6.946A6.132,6.132,0,0,0,136.946,9.7l-2.156,4.671,4.671-2.156a6.132,6.132,0,0,0,2.755-2.754Z",
  transform: "translate(-130)",
  fill: "#c4c4c4",
  fillRule: "evenodd"
})));

var SvgHistoria = function SvgHistoria(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistoria, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/historia.b231af84.svg";
export { ForwardRef as ReactComponent };